/**
 * Determines the color for a Voyager API status code chip based on HTTP status.
 *
 * Color Logic:
 * - 2xx (Success): Green
 * - 4xx (Client Error): Red
 * - 5xx (Server Error): Warning
 * - Other: Default
 *
 * @param statusCode - HTTP status code from the Voyager API response (null if request didn't complete)
 * @returns MUI Chip color: "success" | "error" | "warning" | "default"
 */
export const getVoyagerStatusColor = (
	statusCode: number | null
): "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" => {
	if (statusCode === null) return "default";

	if (statusCode >= 200 && statusCode < 300) return "success";
	if (statusCode >= 400 && statusCode < 500) return "error";
	if (statusCode >= 500) return "warning";

	return "default";
};
